<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" :key="listKey" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(actions)="{ item }">
                        <b-container class="bv-example-row">
                            <b-button size="sm" variant="btn btn-outline-secondary waves-effect waves-light width-sm no-text" @click="onClickVisualizzaFarmaco(item)">
                                <font-awesome-icon icon="eye"> </font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <modal-error ref="cmpModalError"></modal-error>
    </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            currentPage: 1,
            rows: 0,
            perPage: 10000,
            listKey: 0,
            items: [],
            pathResourceFarmaci: "/farmaci",
            linkview: "/bancafarmaci/view/",
            filtroFarmaci: { descrizione: null, atcGmp: null },
            isBusy: false,
            fields: [
                {
                    label: "",
                    key: "index",
                    //    sortable: true,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Nome Farmaco",
                    key: "descrizione",
                    sortable: true,
                    //  thStyle: "width: 50rem",
                },
                {
                    label: "ATC",
                    key: "atcGmp",
                    sortable: true,
                    // thStyle: "width: 7rem",
                },
                {
                    label: "Prezzo",
                    key: "euroPrezzo1",
                    sortable: true,
                    formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroFarmaci"]) {
                me.filtroFarmaci = JSON.parse(sessionStorage["filtroFarmaci"]);
            }
            me.filtroFarmaci.page = me.currentPage;
            me.filtroFarmaci.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResourceFarmaci, me.filtroFarmaci, me.loadDataFarmaciSucess, me.loadDataFarmaciError);
        },
        loadDataFarmaciSucess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.items = [];
            me.items = response.data.data;
            me.rows = response.data.data.length;
            me.listKey++;
        },
        loadDataFarmaciError(error) {
            let me = this;
            me.$emit("afterLoadData");
            me.$refs.cmpModalError.show(error.response.data.messaggio + "#");
        },
        onClickVisualizzaFarmaco(item) {
            let me = this;
            me.$router.replace(me.linkview + item.codiceProdotto).catch((err) => {
                err;
            });
        },
        resetList() {
            let me = this;
            me.items = [];
        },
    },
};
</script>

<style></style>
